import {
  runScheduledTaskNowResponse,
  scheduledTaskRunView,
  scheduledTaskView,
  type CreateScheduledTaskRequest,
  type RunScheduledTaskNowResponse,
  type ScheduledTaskRunView,
  type ScheduledTaskView,
  type UpdateScheduledTaskRequest,
} from '@occ/contracts';
import { del, get, patch, post } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Programador de tareas (Módulo 14): dispara un plugin ya existente sobre un
 * cliente, una sucursal o un nodo, en un horario. Ver
 * `docs/tech-specs/M14-programador-de-tareas.md`.
 */

const asArray = (payload: unknown): unknown[] => (Array.isArray(payload) ? payload : []);

export const listScheduledTasks = async (): Promise<ScheduledTaskView[]> =>
  asArray(await get(ROUTES.scheduledTasks)).map((row) => scheduledTaskView.parse(row));

export const createScheduledTask = async (
  request: CreateScheduledTaskRequest,
): Promise<ScheduledTaskView> => scheduledTaskView.parse(await post(ROUTES.scheduledTasks, request));

export const updateScheduledTask = async (
  id: string,
  request: UpdateScheduledTaskRequest,
): Promise<ScheduledTaskView> =>
  scheduledTaskView.parse(await patch(ROUTES.scheduledTask(id), request));

export const deleteScheduledTask = (id: string): Promise<void> => del(ROUTES.scheduledTask(id));

export const listScheduledTaskRuns = async (id: string): Promise<ScheduledTaskRunView[]> =>
  asArray(await get(ROUTES.scheduledTaskRuns(id))).map((row) => scheduledTaskRunView.parse(row));

/** Disparo manual. Devuelve el identificador de la corrida de inmediato; el reparto sigue detrás. */
export const runScheduledTaskNow = async (id: string): Promise<RunScheduledTaskNowResponse> =>
  runScheduledTaskNowResponse.parse(await post(ROUTES.scheduledTaskRunNow(id)));
